import { Link } from 'react-router-dom'
import { Instagram, Facebook, Music2 } from 'lucide-react'
import { INSTAGRAM_URL, TIKTOK_URL, FACEBOOK_URL } from './constants'
import { useLanguage } from '@/i18n/LanguageContext'

const socials = [
  { label: 'Instagram', href: INSTAGRAM_URL, icon: Instagram },
  { label: 'TikTok', href: TIKTOK_URL, icon: Music2 },
  { label: 'Facebook', href: FACEBOOK_URL, icon: Facebook },
]

export default function Footer() {
  const { t } = useLanguage()
  const year = new Date().getFullYear()

  return (
    <footer className="bg-ink text-cream/80">
      <div className="mx-auto max-w-6xl px-6 py-10 md:py-16">
        <div className="flex flex-col items-center gap-2 text-center md:flex-row md:items-center md:justify-between md:gap-10 md:text-left">
          <div>
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault()
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }}
              aria-label={t.header.backToTop}
              className="inline-block"
            >
              <img
                src="/images/LOGO-orizz2.png"
                alt={t.footer.logoAlt}
                className="h-28 w-auto max-w-full object-contain"
              />
            </a>
          </div>

          <div className="flex flex-col items-center gap-5 md:items-end">
            <div className="flex items-center gap-4">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-colors hover:border-terracotta hover:text-terracotta"
                >
                  <social.icon className="h-4 w-4" strokeWidth={1.8} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-cream/10 pt-6 md:mt-12">
          <p className="text-sm text-cream/50 leading-relaxed text-left">
            {t.footer.copyright.replace('{year}', String(year))}
          </p>
          <p className="mt-2 text-left">
            <Link
              to="/privacy"
              className="text-sm text-cream/50 underline underline-offset-2 transition-colors hover:text-terracotta"
            >
              {t.footer.privacyLink}
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}
